import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreplacementTrainingListComponent } from './preplacement-training-list/preplacement-training-list.component';
import { PreplacementTrainingCreateComponent } from './preplacement-training-create/preplacement-training-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: PreplacementTrainingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: PreplacementTrainingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'preplacement-training-create/:id',
        component: PreplacementTrainingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreplacementTrainingRoutingModule { }
